import styled from 'styled-components';
import { RadioButton } from '../RadioButton';

// ======================================================
// Popup Sections
// ======================================================
export const Container = styled.div`

  /* The container <div> - needed to position the dropdown content */
  position: relative;
  display: inline-block;

  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    background-color: transparent;
    min-width: 160px;
    z-index: 1;
    top: 20px;
  }

  /* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
  .show {display:block;}
`;

export const PopupClickableWrapper = styled.div`
  width: 100%;
`;

export const PopupBodyContainerWrapper = styled.div`
`;

// ======================================================
// Popup Content
// ======================================================
export const PopupBodyContainer = styled.div`
  background: #FFFFFF;
  border: 0.3px solid ${(props) => props.theme.colors.diviserSmoothColor};
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
`;

export const Head = styled.div`
  color: #610082;
  padding: 3px;
  margin: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.diviserColor};

  overflow: hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
  width: ${(props) => `${props.headWidth}px`};
`;

export const InnerContainer = styled.div`
  margin: 0px 10px 10px 10px
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Radio = styled(RadioButton)`
  color: #610082;
  padding: 3px;
  width: 40px;

  .radio-button-control {
    margin-right: 3px;
  }
`;

export const Clickable = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: calc(100% / 3);

  .clickable {
    width: 100%;
  }
`;
